var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7368 10.7368C12.5972 10.7368 14.1053 9.22875 14.1053 7.36842C14.1053 5.50809 12.5972 4 10.7368 4C8.87652 4 7.36842 5.50809 7.36842 7.36842C7.36842 9.22875 8.87652 10.7368 10.7368 10.7368Z",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.7368H18.3158M18.3158 10.7368H16.6316M18.3158 10.7368V9.05261M18.3158 10.7368V12.421M17.472 17.4737C17.4731 17.3356 17.4737 17.1952 17.4737 17.0526C17.4737 14.96 14.4573 13.2631 10.7368 13.2631C7.01642 13.2631 4 14.96 4 17.0526C4 19.1452 4 20.8421 10.7368 20.8421C12.6156 20.8421 13.9705 20.7099 14.9474 20.4741",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasters);
export default __webpack_public_path__ + "static/media/Masters.23002202b365e1bd10f78e858f7e695d.svg";
export { ForwardRef as ReactComponent };